import React from 'react';
import PropTypes from 'prop-types';
import Career from './Career';

const Department = ({ department, careers }) => (
    <div className="career">
        <h3 className="career-title">{department}</h3>
        <hr />
        {careers.length && careers.map((career) => (
            <Career
                key={career?.id}
                career={career}
            />
        ))}
    </div>
);

Department.propTypes = {
    department: PropTypes.string.isRequired,
    careers: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Department;
